import { useState, useEffect } from "react";
import { Button, Card, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrash } from "react-icons/fa";
import { getroomType, deleteroomType } from "../../store/slices/roomtype";
import { useParams } from "react-router-dom";
import DeleteModal from "./deletepopup";

export default function HotelRooms() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { roomTypeList = [] } = useSelector((state) => state.roomType);

  const [currentPage, setCurrentPage] = useState(1);
  const pageLimit = 20;

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const fetchHotels = async () => {
    try {
      const item = { hotelId: id };
      await dispatch(getroomType(item)).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchHotels();
  }, []);

  const roomList = Array.isArray(roomTypeList) ? roomTypeList : [];

  const totalPages = Math.ceil(roomList.length / pageLimit);
  const startIndex = (currentPage - 1) * pageLimit;
  const currentRooms = roomList.slice(startIndex, startIndex + pageLimit);

  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deleteroomType(selectedId)).unwrap();

      setDeleteStatus("success");

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/hotel/home" className="breadcrumb-link active">
            Home
          </Link>
          <span className="breadcrumb-separator">|</span>
          <Link to="/hotel/roomtype" className="breadcrumb-link active">
            Hotels
          </Link>
          <span className="breadcrumb-separator">|</span>
          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/hotel/roomtype")}
          >
            Room Type
          </span>
        </div>
        <button
          className="add-outlet-btn"
          onClick={() => navigate(`/hotel/addroom-type/${id}`)}
        >
          + Add Room
        </button>
      </div>

      <Container fluid>
        <Card style={{ border: "none" }}>
          <Card.Body>
            <div className="common-table-wrapper">
              <table className="common-table">
                <thead>
                  <tr>
                    <th style={{ width: "80px" }}>#</th>
                    <th className="text-center">Room Type</th>
                    <th className="text-center">Base Price</th>
                    <th className="text-center">Max. Occupancy</th>
                    <th className="text-center">Extra Bed Allowed</th>
                    <th className="text-center">Extra Bed price</th>
                    <th className="text-center">Max. Extra Bed Allowed</th>
                    <th className="text-center">Meals</th>

                    <th style={{ width: "120px", textAlign: "center" }}>
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {/* Empty */}
                  {currentRooms.length === 0 && (
                    <tr>
                      <td colSpan="9" className="text-center py-4 text-muted">
                        No Data Found
                      </td>
                    </tr>
                  )}

                  {/* Data */}
                  {currentRooms.map((item, index) => (
                    <tr key={item._id}>
                      <td className="text-center">{startIndex + index + 1}</td>

                      <td className="text-center">{item.name}</td>
                      <td className="text-center">₹{item.basePrice}</td>
                      <td className="text-center">{item.maxOccupancy}</td>
                      <td className="text-center">
                        {item.extraBedAllowed ? (
                          <span className="badges bg-success">Yes</span>
                        ) : (
                          <span className="badges bg-secondary">No</span>
                        )}
                      </td>

                      <td className="text-center">₹{item.extraBedPrice}</td>
                      <td className="text-center">{item.maxExtraBeds}</td>
                      <td className="text-center">
                        <div className="d-flex flex-column gap-1">
                          {["breakfast", "lunch", "dinner"].map((meal) => {
                            const m = item.meals?.[meal];
                            if (!m) return null;

                            return (
                              <div key={meal}>
                                <strong className="text-capitalize">
                                  {meal}:
                                </strong>
                                <span className="text-muted">₹{m.price}</span>
                              </div>
                            );
                          })}
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="action-btn-group">
                          <button
                            className="action-btn edit-btn"
                            onClick={() =>
                              navigate(`/hotel/editroom-type/${item._id}`)
                            }
                          >
                            <FaEdit size={14} />
                          </button>

                          <button
                            className="action-btn delete-btn"
                            onClick={() => {
                              setSelectedId(item._id);
                              setShowDelete(true);
                            }}
                          >
                            <FaTrash size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-end gap-2 p-3">
                  <Button
                    size="sm"
                    variant="light"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((p) => p - 1)}
                  >
                    Prev
                  </Button>

                  {[...Array(totalPages)].map((_, i) => (
                    <Button
                      key={i}
                      size="sm"
                      variant={currentPage === i + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </Button>
                  ))}

                  <Button
                    size="sm"
                    variant="light"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((p) => p + 1)}
                  >
                    Next
                  </Button>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </Container>

      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
